import { createSelector } from 'reselect';

import { learningYearFinalPerformanceSelector } from './learningYearPerformanceSelector';

export const finalMarkDiagramLearningYearsSelector = createSelector(
  [learningYearFinalPerformanceSelector],
  (finalPerformance) =>
    finalPerformance.content
      .filter((perfomance) => perfomance.subjects.some((subject) => subject.markValue))
      .map((perfomance) => perfomance.year),
);
